import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-of-content',
  templateUrl: './table-of-content.component.html',
  styleUrls: ['./table-of-content.component.css']
})
export class TableOfContentComponent implements OnInit {

  status = 'show';
  readMore = false;

  @Input() sections;
  @Input() previewItems;
  @Output() public selection = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    !this.sections? this.sections = [] : null;
    !this.previewItems? this.previewItems = 3 : null;
  }

  select(section){
    if(section && section['id']){
      this.selection.emit(section.id);
    }else{
      debugger
    }
  }

  changeStatus(){
    this.status == 'hidden'? this.status = 'show' : this.status = 'hidden';
  }

  showMore(){
    this.readMore = !this.readMore;
  }
  getTitle(data){
    data? null : data = {};
    data.title? null : data['title'] = '';
    return data.title;
  }

  getOptions(){
    let res = [];
    let counter = 0;
    for(let section of this.sections){
      if(counter<this.previewItems){
        res.push(section);
        counter++;
      }
    }
    return res;
  }

}

